var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430.3 328.9",
    style: {
      enableBackground: "new 0 0 430.3 328.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#59595B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.4,6.1h210.5v58.4h-77.2v261.8H84.6V64.6H7.4V6.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.8,276.7l36.5-40.2C275,258.2,297.9,269,323,269c13.3,0,24-3.1,32-9.3c8-6.2,12-14.7,12-25.4 c0-7.9-2.6-14.7-7.8-20.3c-5.2-5.6-12.1-10.4-20.6-14.2c-8.5-3.8-17.8-7.5-27.9-11c-10.1-3.5-20.2-7.8-30.4-12.7 c-10.2-4.9-19.6-10.6-28.1-17.1c-8.5-6.5-15.4-15.3-20.6-26.5c-5.2-11.1-7.8-24.1-7.8-38.7c0-26,8.7-47,26.1-63.3 c17.4-16.2,40.7-24.3,70-24.3c17.5,0,34.9,4.1,52.2,12.3c17.3,8.2,32,20.7,44.3,37.7l-40.8,35.1c-6-8.5-14-15.2-23.9-20.1 c-9.9-4.9-19.9-7.5-29.8-7.8c-12.3,0-22.2,2.8-29.8,8.5c-7.6,5.6-11.4,12.7-11.4,21.2c0,7.9,3.5,14.7,10.6,20.5 c7.1,5.8,15.9,10.4,26.5,13.8c10.6,3.4,22.1,7.7,34.5,12.9c12.4,5.2,23.9,11,34.5,17.4c10.6,6.3,19.4,15.8,26.5,28.4 c7.1,12.6,10.6,27.4,10.6,44.6c0,28.8-9.2,52-27.5,69.6c-18.3,17.6-42.4,26.5-72.2,26.5c-0.5,0-1,0-1.6,0 C280.2,326.6,245.3,309.9,217.8,276.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsIcon);
export default __webpack_public_path__ + "static/media/ts-icon.e8cb657523c38b6abdd9c5d00bcec140.svg";
export { ForwardRef as ReactComponent };